import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({

    container: {
        // marginTop: theme.spacing(8),
        paddingTop: theme.spacing(2),
        //  textAlign: 'center'
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },

}))

export default useStyles;